<template>
  <span>{{ countdowns.time }}</span>
</template>
<script>
import { formatTime } from "@/hooks/function";
export default {
  components: {},
  props: {
    startTime: {
      type: String,
      default: "",
    },
    minute: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      countdowns: {
        timer: null,
        time: "",
        once: false,
      },
    };
  },
  computed: {},
  mounted() {
    if (this.startTime) {
      this.onCountdownCheck();
    }
  },
  destroyed() {
    if (this.countdowns.timer) clearTimeout(this.countdowns.timer);
  },
  methods: {
    onCountdownCheck() {
      if (this.countdowns.timer) clearTimeout(this.countdowns.timer);
      const duration =
        this.minute * 1000 * 60 -
        (Date.now() - formatTime(this.startTime).getTime());
      if (duration > 0) {
        if (!this.countdowns.once) this.countdowns.once = true;
        this.countdowns.time = this.onCountdownTransform(duration);
        this.countdowns.timer = setTimeout(this.onCountdownCheck, 1000);
      } else {
        this.countdowns.time = "";
        if (this.countdowns.once) {
          this.$emit("end");
        }
      }
    },
    onCountdownTransform(duration) {
      const minute = Math.floor(duration / (1000 * 60));
      const seconds = Math.floor((duration % (1000 * 60)) / 1000);
      return `${minute.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.link {
  margin-left: 20px;
  color: #4187f7;
  cursor: pointer;
}
.co-copy {
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  margin-left: 8px;
  margin-top: -1px;
  padding: 0 8px;
  font-size: 12px;
  display: inline-block;
  cursor: pointer;
  transform: scale(0.9);
  color: #999;
  &:hover {
    opacity: 0.8;
  }
  &.disabled {
    border-color: #999;
    color: #666;
    opacity: 1;
    cursor: default;
  }
  .input {
    position: fixed;
    left: 100%;
    top: -100%;
    height: 1px;
    width: 1px;
    border: none;
    overflow: hidden;
  }
}
</style>
